
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as g3ShrQODtENAjlH159psm_IcpbnionR_47d8iACTIOMAMeta } from "/codebuild/output/src2494774231/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexrVhM1bphdo7vtNH1plTzD4HNJSvGAW8266C1PPxE2mkMeta } from "/codebuild/output/src2494774231/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchoRPDVPkk31ARqsqKA31ZCtKYuZXf_HHt4rF8gFpQkPcMeta } from "/codebuild/output/src2494774231/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexgEOmRTjP6tQkMVuUISSg0MzS54DWXlOC0efDlCyxD_MMeta } from "/codebuild/output/src2494774231/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93Cz1ols_45vX2uzmXGVAkZdD1zgF7hgvpCpXjazqad6dlYMeta } from "/codebuild/output/src2494774231/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as index1yXo9zKpnfOGeqhYkM1ChiB_mSGbRP2fPpNM4MpYsgMMeta } from "/codebuild/output/src2494774231/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93fMKA9jXqqTnwo_45BxOgrUO9UJ9tgfH1Jop_45mLeSBleoYMeta } from "/codebuild/output/src2494774231/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexez0uZaou5_451qi_45zIDPoPCnJ2zIJrT0HngdumxT7jRsIMeta } from "/codebuild/output/src2494774231/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_9357QVFEZJ6OPdihnra3NEdrQ8YF_45b6f8J9Fgi0cqkns8Meta } from "/codebuild/output/src2494774231/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexMMRabcElKwtNpDApOKTcU6FamR09L0xKGqgdekYS4YsMeta } from "/codebuild/output/src2494774231/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexxUsoORk9VNK8aDr4NZnQmp6ZWvMPbX8CBFtGyskrG14Meta } from "/codebuild/output/src2494774231/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src2494774231/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src2494774231/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src2494774231/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src2494774231/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src2494774231/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: index1yXo9zKpnfOGeqhYkM1ChiB_mSGbRP2fPpNM4MpYsgMMeta || {},
    component: () => import("/codebuild/output/src2494774231/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src2494774231/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexez0uZaou5_451qi_45zIDPoPCnJ2zIJrT0HngdumxT7jRsIMeta || {},
    component: () => import("/codebuild/output/src2494774231/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src2494774231/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexMMRabcElKwtNpDApOKTcU6FamR09L0xKGqgdekYS4YsMeta || {},
    component: () => import("/codebuild/output/src2494774231/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexxUsoORk9VNK8aDr4NZnQmp6ZWvMPbX8CBFtGyskrG14Meta || {},
    component: () => import("/codebuild/output/src2494774231/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]